import { render, staticRenderFns } from "./pill.vue?vue&type=template&id=6d8e2646&scoped=true&"
import script from "./pill.vue?vue&type=script&lang=js&"
export * from "./pill.vue?vue&type=script&lang=js&"
import style0 from "./pill.vue?vue&type=style&index=0&id=6d8e2646&prod&lang=less&"
import style1 from "./pill.vue?vue&type=style&index=1&id=6d8e2646&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8e2646",
  null
  
)

export default component.exports